import { Box, Checkbox, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

let desc = '';

class PagosRealizados extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
            consulta: {
                numeroFuncionario: '',
                anio: '',
            },
            datosConsulta: [],
            checkAdd: false,
            codigosInforme: [],
            numeroNombre: [],

            pago: {
                idPagosRealizados: '',
                codigo: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                anio: '',
                dias: '',
            },
            datoModal: {},
            modalCancelar: false,
            modalModificar: false,
        }
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarCambioConsulta = this.manejarCambioConsulta.bind(this);
        this.pagoAgregar = this.pagoAgregar.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioPago = this.manejarEnvioPago.bind(this);
        this.manejarVolver = this.manejarVolver.bind(this);
        this.manejarCancelar = this.manejarCancelar.bind(this);
        this.manejarModificar = this.manejarModificar.bind(this);
        this.manejarEnvioCancelar = this.manejarEnvioCancelar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.manejarAtrasMod = this.manejarAtrasMod.bind(this);
        this.cerrarModalMod = this.cerrarModalMod.bind(this);
    }
    async componentDidMount(){
        this.setState({
            codigosInforme: [
                {
                    idCodigosInformesPersonal: 2,
                    descripcion: 'ANTIGÜEDAD',
                },
                {
                    idCodigosInformesPersonal: 1,
                    descripcion: 'REGLAMENTARIA',
                },
                {
                    idCodigosInformesPersonal: 57,
                    descripcion: 'LICENCIA EXTRAORDINARIA COVID',
                },
            ]
        })

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }
    render(){
        return (
            <>
                <Container>
                    <h3>Pagos Realizados</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    <br/>
                    {this.state.consultaRealizada
                    ?
                        null
                    :
                        <FormControlLabel label='Agregar Pago' control={<Checkbox checked={this.state.checkAdd} onChange={this.pagoAgregar} id='add'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    }
                    {this.state.consultaRealizada || this.state.checkAdd
                    ?
                        null
                    :
                        <Container>
                            <form className='formulario1'  onSubmit={this.manejoEnvioConsulta}>
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={3}>
                                            <Item>Número de Funcionario</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.consulta.numeroFuncionario} onChange={this.manejarCambioConsulta} type="number" />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>Ejercicio</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.consulta.anio} onChange={this.manejarCambioConsulta}/>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        </Container>
                    }
                    {this.state.checkAdd
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Concepto</StyledTableCell>
                                            <StyledTableCell>Número</StyledTableCell>
                                            <StyledTableCell>Nombre</StyledTableCell>
                                            <StyledTableCell>Días</StyledTableCell>
                                            {this.state.pago.codigo === '57' ? <StyledTableCell></StyledTableCell> : <StyledTableCell>Ejercicio</StyledTableCell>}
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            {this.state.codigosInforme.map((name) => {
                                                if(name.idCodigosInformesPersonal === this.state.pago.codigo){
                                                    desc = name.descripcion;
                                                }
                                            })}
                                            {this.state.modalModificar
                                            ?
                                                <StyledTableCell>{desc}</StyledTableCell>
                                            :
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.pago.codigo} onChange={this.manejarCambiosDatos}>
                                                        <option value=''></option>
                                                        {this.state.codigosInforme.map((name) =>
                                                            <option
                                                            key={name.idCodigosInformesPersonal}
                                                            value={name.idCodigosInformesPersonal}
                                                            >{name.descripcion}</option>
                                                            )}
                                                    </select>
                                                </StyledTableCell>
                                            }
                                            {this.state.modalModificar ? <StyledTableCell>{this.state.pago.numeroFuncionario}</StyledTableCell> : <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.pago.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>}
                                            <StyledTableCell>{this.state.pago.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='dias' value={this.state.pago.dias} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            {this.state.pago.codigo === '57' ? <StyledTableCell></StyledTableCell> : <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.pago.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>}
                                            {this.state.modalModificar ? <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={this.manejarEnvioModificar}>Modificar</button></StyledTableCell> : <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={this.manejarEnvioPago}>Agregar</button></StyledTableCell>}
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    :
                        null
                    }
                    {this.state.consultaRealizada
                    ?
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Estado</StyledTableCell>
                                        <StyledTableCell>Concepto</StyledTableCell>
                                        <StyledTableCell>Número</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>Ejercicio</StyledTableCell>
                                        <StyledTableCell>Días</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.datosConsulta.map((datosAg) => (
                                        <StyledTableRow key={datosAg.idPagosRealizados}>
                                            <StyledTableCell>{datosAg.estado}</StyledTableCell>
                                            <StyledTableCell>{datosAg.concepto}</StyledTableCell>
                                            <StyledTableCell>{datosAg.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosAg.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosAg.anio}</StyledTableCell>
                                            <StyledTableCell>{datosAg.dias}</StyledTableCell>
                                            {datosAg.estadoMod === 2 ? <StyledTableCell></StyledTableCell> : <StyledTableCell><button type="button" className="btn btn-outline-danger mx-2" onClick={() => this.manejarCancelar(datosAg)}>Cancelar</button></StyledTableCell>}
                                            {datosAg.estadoMod === 2 ? <StyledTableCell></StyledTableCell> : <StyledTableCell><button type="button" className="btn btn-outline-success mx-2" onClick={() => this.manejarModificar(datosAg)}>Modificar</button></StyledTableCell>}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    :
                        null
                    }
                    {this.state.consultaRealizada
                    ?
                        <button style={{marginTop: '1rem'}} type="button" className="btn btn-outline-primary mx-2" onClick={this.manejarVolver}> Atras</button>
                    :
                        null
                    }
                    {this.state.modalModificar
                    ?
                        <button style={{marginTop: '1rem'}} type="button" className="btn btn-outline-primary mx-2" onClick={this.manejarAtrasMod}> Atras</button>
                    :
                        null
                    }
                    <Modal open={this.state.modalCancelar}>
                        <form className='formulario1'>
                            <Box sx={styleModal}>
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={3.5}>

                                    </Grid>
                                    <Grid item xs={5}>
                                        <Item>
                                            Confirmar Cancelar
                                        </Item>
                                    </Grid>
                                    <Grid item xs={3.5}>

                                    </Grid>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioCancelar}>Confirmar</button>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Modal>
                </Container>
            </>
        )
    }

    async manejoEnvioConsulta(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.consulta]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_pagosRealizados.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            loading: true,
            notificaciones: null,
            errores: exito[0],
        })

        this.setState({
            loading: false,
        })

        if(exito[0] === 'ok'){
            this.setState({
                datosConsulta: exito[1],
                consultaRealizada: true,
                notificaciones: null,
                errores: null,
            })
        }
    }

    manejarCambioConsulta(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.consulta;
            numFunActualizado[clave] = valor;
            return{
                consulta: numFunActualizado,
            };
        });
    }

    pagoAgregar(){
        if(this.state.checkAdd){
            this.setState({
                checkAdd: false,
            })
        }else{
            this.setState({
                checkAdd: true,
            })
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const numFunActualizado = state.pago;
            numFunActualizado[clave] = valor;
            
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }
            
            return{
                pago: numFunActualizado,
            };
        });
    }

    async manejarEnvioPago(e){
        e.preventDefault();
        if((this.state.pago.codigo === '')){
            this.setState({
                errores: 'Debe ingresar un concepto',
            })
        }else if((this.state.pago.numeroFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario',
            })
        }else if((this.state.pago.numeroFuncionario !== '') && (this.state.pago.nombreFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido',
            })
        }else if((this.state.pago.dias === '') || (this.state.pago.dias <= 0)){
            this.setState({
                errores: 'La cantidad de días debe ser mayor a 0',
            })
        }else if((this.state.pago.codigo !== '57') && (this.state.pago.anio === '')){
            this.setState({
                errores: 'Debe ingresar el ejercicio',
            })
        }else{
            this.setState({
                loading: true,
                errores: null,
                notificaciones: null,
            })

            const cargaUtil = JSON.stringify([this.state.pago, sessionStorage.numeroFuncionarioAsociado]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_pagoRealizado.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
            })
            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    loading: false,
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    pago: {
                        idPagosRealizados: '',
                        codigo: '',
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        anio: '',
                        dias: '',
                    },
                })
            }

        }
    }

    manejarVolver(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
            datosConsulta: [],
        })
    }

    manejarCancelar(dato){
        this.setState({
            datoModal: dato,
            modalCancelar: true,
        })
    }

    async manejarEnvioCancelar(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.datoModal, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/cancelar_pagoRealizado.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            loading: false,
        })

        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'El pago fue cancelado',
                checkAdd: false,
                modalModificar: false,
                modalCancelar: false,
                consultaRealizada: false,
            })
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            modalCancelar: false,
            datoModal: {},
        })
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
        if((this.state.pago.dias === '')){
            this.setState({
                errores: 'Debe ingresar la cantidad de días',
                notificaciones: null,
            })
        }else if((this.state.pago.anio === '')){
            this.setState({
                errores: 'Debe ingresar el año del ejercicio',
                notificaciones: null,
            })
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.pago, sessionStorage.numeroFuncionarioAsociado]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/modificar_pagoRealizado.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
                loading: false,
            })
            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: 'Datos ingresados correctamente',
                    checkAdd: false,
                    modalModificar: false,
                })
            }
        }
    }

    cerrarModalMod(e){
        e.preventDefault();
        this.setState({
            modalModificar: false,
            datoModal: {},
        })
    }

    manejarModificar(dato){
        this.setState({
            datoModal: dato,
            modalModificar: true,
            pago: {
                idPagosRealizados: dato.idPagosRealizados,
                codigo: dato.codigo,
                numeroFuncionario: dato.numeroFuncionario,
                nombreFuncionario: dato.nombreFuncionario,
                anio: dato.anio,
                dias: dato.dias,
            },
            checkAdd: true,
            consultaRealizada: false,
        })
    }

    manejarAtrasMod(e){
        e.preventDefault();
        this.setState({
            datoModal: {},
            modalModificar: false,
            pago: {
                idPagosRealizados: '',
                codigo: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                anio: '',
                dias: '',
            },
            checkAdd: false,
            consultaRealizada: true,
        })
    }

}

export default PagosRealizados